/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_1Inputs */

const en_cap_promise_1 = /** @type {(inputs: Cap_Promise_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your knowledge`)
};

const lv_cap_promise_1 = /** @type {(inputs: Cap_Promise_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu zināšanas`)
};

/**
* | output |
* | --- |
* | "Your knowledge" |
*
* @param {Cap_Promise_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_1 = /** @type {((inputs?: Cap_Promise_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_1(inputs)
	return en_cap_promise_1(inputs)
});